import { useEffect } from "react";
import { errorSnackbar } from "@src/cloud-connect/snackbars/entities/snackbar-launcher";

const SNACKBAR_TIMEOUT = 5000;

/**
 * Raises one error snackbar per distinct message. Pass the message the backend
 * returned (`parseAxiosApiError` output), or null when there is no error.
 *
 * The effect's only dependency is the string itself, and that is what dedupes:
 * React re-runs it when the text changes and never while it stays the same, so
 * a re-render for another reason (language change, parent state update) cannot
 * stack a second toast. When the error clears and the same text comes back, the
 * dependency went null in between, so it counts as a new failure and toasts
 * again.
 *
 * Shared by the editor (`/dashboard-builder`, list + detail failures) and the
 * viewer (`/dashboard`, its own list + detail failures) so the dedupe rule
 * lives in one place. The canvas and the placeholder components show translated
 * generic copy instead; only the toast carries the backend's own text.
 */
export const useErrorSnackbar = (errorMessage: string | null): void => {
  useEffect(() => {
    if (!errorMessage) return;
    errorSnackbar(errorMessage, SNACKBAR_TIMEOUT);
  }, [errorMessage]);
};
